import { defineComponent } from 'vue'

import { createVueApp } from '@/entrypoints/createVueApp'

import SiteFooter from '../components/common/nav/SiteFooter'
import ContentPackages from '../components/packages/ContentPackages'

const ContentPackagesApp = defineComponent({
	name: 'ContentPackagesPage',

	setup() {
		return () =>
			<>
				<ContentPackages />
				<SiteFooter />
			</>
	},
})

export default function () {
	const app = createVueApp(ContentPackagesApp)

	app.mount('#contentPackages')
}
